define([
	"dojo/_base/declare",
	"csi/action/_ImageBrowseMixin",
	"csi/action/Controller",
	"csi/comm",
	"csi/reflection",
	"csi/xml"
], function(declare, _ImageBrowseMixin, Controller, comm, reflection, xml) {

	return declare([Controller, _ImageBrowseMixin], {
		preProcess: function() {
			// summary: determine if selecting one or many images
			this.bOneImage = (this.widget.imageSpec.type === xml.ATTR_REF);
			this.inherited(arguments);
		},

		toWriter: function() {
			// summary: add selected image(s) to node
			const {heading, type} = this.widget.imageSpec;
			this._toWriterImages(heading.m_id, type);
		},

		/** 
		 * @override
		 * Refresh Scene7 images in view even on failure
		 */
		postProcess: function(/*Boolean*/bStatus, /*Boolean*/bRepeat) {
			if (!bStatus) {
				this._postProcess(false);
			}

			this.inherited(arguments);
		},

		/** 
		 * @override
		 * Refresh images in view on successful action
		 */
		postProcessSuccess() {
			this._postProcess(true);
		},

		/**
		 * Refresh view after action is done based on status
		 * @param {boolean} bStatus 
		 */
		_postProcess(bStatus) {
			var view = this.widget;
			var selectedImage = this._firstKey;

			if (this._bRefreshScene7) {
				// if no image selected, then keep currently selected image in view
				if (!bStatus) {
					selectedImage = view.getCurrentImageKey();
				}

				// if having Scene7 support, then need to query for potentially new images before refreshing view
				comm.getNodeRequest(this.m_urlNode).addDependencyPaths([xml.path(reflection.ATTR_IMAGES)]).go().then(function(response) {
					view.cacheView.cacheResponse(response);
					view.refreshImages(selectedImage);
				});
			} else if (bStatus) {
				// if new image(s) selected, then refresh and show first one
				view.refreshImages(selectedImage);
			}
		}
	});
});